import { render, staticRenderFns } from "./PartyOnboardingCompliance.vue?vue&type=template&id=a2bad860&scoped=true"
import script from "./PartyOnboardingCompliance.vue?vue&type=script&lang=js"
export * from "./PartyOnboardingCompliance.vue?vue&type=script&lang=js"
import style0 from "./PartyOnboardingCompliance.vue?vue&type=style&index=0&id=a2bad860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bad860",
  null
  
)

export default component.exports